import "babel-polyfill";
import "./infrastructure/config/configure";
import "./main.css";
import { loadPolyfills } from "./infrastructure/polyfills";
import { getAppLogger } from "@dcl-ue/shared-components/src/AppLogger/AppLogger";
import { initEnvVariables } from "@dcl-ue/shared-components/src/appEnvVariables";
import { getLocalFromLocation } from "./infrastructure/config/url";

const logException = (err: any) => {
  try {
    const appLogger = getAppLogger();
    appLogger.error(err);
  } catch {}
};

const buildErrorPageUrl = (errorCode: string): string => {
  const local = getLocalFromLocation(window.location);
  const errorPageURL = `${window.location.protocol}//${window.location.host}/${local}/errors/${errorCode}.html`;

  return errorPageURL;
};

const handleUnexpectedException = (err: any) => {
  const errorCode: string = err?.code || "general";
  const errorPageUrl = buildErrorPageUrl(errorCode);

  window.location.assign(errorPageUrl);
};

loadPolyfills()
  .then(() => {
    initEnvVariables();

    return import(
      /* webpackChunkName: "app-main" */
      "./infrastructure/config/bootstrapper"
    );
  })
  .then(async ({ bootstrapApplication }) => {
    // eslint-disable-next-line
    return bootstrapApplication().catch((err) => {
      logException(err);
      handleUnexpectedException(err);
    });
  })
  .then(() => {
    // this polyfill is for lazy loading images in older browsers, and is needed
    // even in newer browsers to allow images in noscript tags to show. This polyfill
    // must be loaded after rehydration completes rather than before.
    require("loading-attribute-polyfill");
  });
